<template>
    <div class="w-full h-full">
        <Header title="Create a new campaign" icon="Plus" />
        <WhiteBox title="1) Name & timeframe">
            <template v-slot:content>
                <div class="-mt-2 rounded col-span-full grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
                    <CustomInput v-model="campaign.name" class="col-span-1 sm:col-span-2" label="Campaign name"
                        placeholder="Describe this campaign" />
                    <CustomInput v-model="campaign.startDate" class=" " type="date" label="Start date"
                        placeholder="07/10/2024" />
                    <CustomInput v-model="campaign.endDate" class=" " type="date" label="End date"
                        placeholder="14/11/2024" />
                </div>
            </template>
        </WhiteBox>
        <div class="grid grid-cols-12 gap-x-5">
            <div class="col-span-12 lg:col-span-5 xl:col-span-4">
                <WhiteBox title="2) Select campaign type" fullWidthTitle>
                    <template v-slot:content>
                        <div class="col-span-1">
                            <div class="h-20">
                                <CustomSelect :options="campaignType" pre-select="TAKEOVER" v-model="campaign.slot"
                                    label="Select campaign type" />
                            </div>
                        </div>

                        <div v-if="campaign.slot == 'TAKEOVER'" class="-mt-2 rounded grid grid-cols-1 gap-4">
                            <div class="col-span-1">
                                <p
                                    class="w-full mt-1 font-medium text-xs px-2 py-1.5 text-blue-800 bg-blue-50 border border-blue-300 rounded-lg">
                                    Please upload a 1080x1080 pixel image to display as your ad creative for this
                                    campaign.
                                </p>
                                <CustomInput class="w-full mt-2" type="file" placeholder="Boogi" label="Select image"
                                    @change="uploadFile" ref="fileInput" accept=".png" />
                                <p v-if="errorMessage"
                                    class="w-full mt-1 font-medium text-xs px-2 py-1.5 text-red-800 bg-red-50 border border-red-300 rounded-lg">
                                    {{ errorMessage }}
                                </p>
                            </div>
                            <div class="col-span-2">
                                <div>
                                    <p class="font-semibold text-gray-700 text-sm pb-1">Campaign asset:</p>
                                    <div class="w-full">
                                        <img v-if="assetURL" :src="assetURL"
                                            class="w-full rounded-lg border border-gray-300">
                                        <img v-else src="https://placehold.co/1080x1080"
                                            class="w-full rounded-lg border border-gray-300">
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div v-if="campaign.slot == 'FEATURE'" class="-mt-2 rounded grid grid-cols-1 gap-4">
                            <div class="col-span-1">
                                <p
                                    class="w-full mt-1 font-medium text-xs px-2 py-1.5 text-blue-800 bg-blue-50 border border-blue-300 rounded-lg">
                                    Please upload a 1280 x 720 pixel image to display as your ad creative for this
                                    campaign.
                                </p>
                                <CustomInput class="w-full mt-2" type="file" placeholder="Boogi" label="Select image"
                                    @change="uploadFile" ref="fileInput" accept=".png" />
                                <p v-if="errorMessage"
                                    class="w-full mt-1 font-medium text-xs px-2 py-1.5 text-red-800 bg-red-50 border border-red-300 rounded-lg">
                                    {{ errorMessage }}
                                </p>
                            </div>
                            <div class="col-span-2">
                                <div>
                                    <p class="font-semibold text-gray-700 text-sm pb-1">Campaign asset:</p>
                                    <div class="w-full">
                                        <img v-if="assetURL" :src="assetURL"
                                            class="w-full rounded-lg border border-gray-300">
                                        <img v-else src="https://placehold.co/1280x780"
                                            class="w-full rounded-lg border border-gray-300">
                                    </div>
                                </div>
                            </div>

                        </div>
                    </template>
                </WhiteBox>
            </div>
            <div class="col-span-12 lg:col-span-7 xl:col-span-8">
                <WhiteBox title="3) Select relevant audiences" fullWidthTitle>
                    <template v-slot:buttons>

                    </template>
                    <template v-slot:content>
                        <div :key="index">
                            <div class="mt-6">
                                <SearchBar placeholderText="Search for an audience"
                                    @search="(val) => { getRetailerBySearch(0, 50, val); showResultsTable = true }">
                                    <CustomButton small text="" type="default" icon="X"
                                        @click="retailers = []; showResultsTable = false;" />
                                </SearchBar>
                            </div>
                            <EasyDataTable class="" v-if="audiences.length > 0" :headers="headersTable1"
                                :items="audiences" :loading="loading" v-model:server-options="serverOptions"
                                :server-items-length="serverItemsLength" :hide-footer="true" :no-hover="true"
                                :table-min-height="false">
                                <!-- Loading State -->
                                <template #loading>
                                    <div class="p-4 w-full flex justify-center">
                                        <svg class="animate-spin text-gray-400 w-12 h-12"
                                            xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                                stroke-width="4"></circle>
                                            <path class="opacity-75" fill="currentColor"
                                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                            </path>
                                        </svg>
                                    </div>
                                </template>

                                <!-- Empty State -->
                                <template #empty-message>
                                    <div class="flex justify-center py-4">
                                        <div
                                            class="flex justify-center items-center text-gray-500 rounded-full bg-gray-50 px-5 py-2">
                                            <p class="text-sm mr-2">No results</p>
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0 1 12 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5" />
                                            </svg>
                                        </div>
                                    </div>
                                </template>
                                <template #header-action="header">
                                    <div class="w-full text-right">
                                        {{ header.text }}
                                    </div>
                                </template>
                                <!-- Retailer Name -->
                                <template #item-retailer="retailers">

                                    <LogoAndText class="text-xs" :logo="retailers.retailer.logo"
                                        :text="retailers.retailer.retailerName" />
                                </template>

                                <!-- Retailer Website -->
                                <template #item-website="retailers">
                                    {{ retailers.retailer.retailerWebsite }}
                                </template>

                                <!-- Action Buttons -->
                                <template #item-action="retailers">
                                    <div class="flex justify-end items-center py-1 gap-1">
                                        <CustomButton small text="Select audience" type="navigate" icon="Plus" @click="
                                            selectedAudiences.push({ ...retailers.audience });
                                        " />
                                    </div>
                                </template>
                            </EasyDataTable>

                            <div v-if="selectedAudiences.length > 0" class="mt-4">
                                <p class="font-semibold text-gray-700 text-sm pb-1">Selected audience:</p>
                                <div v-for="(audience, index) in selectedAudiences" :key="index"
                                    class="bg-gray-50 border border-gray-300 rounded-lg px-3 py-2 mb-2">
                                    <div class="flex justify-between items-center">
                                        <p class="text-sm font-medium">{{ audience.name }}</p>
                                        <CustomButton id="removeRetailerRule" small icon="Trash2" type="warning"
                                            @click="selectedAudiences.splice(index, 1)" />
                                    </div>

                                </div>
                            </div>
                        </div>
                    </template>
                </WhiteBox>
                <WhiteBox title="4) Select campaign offer" fullWidthTitle>
                    <template v-slot:buttons>
                    </template>
                    <template v-slot:content>
                        <div :key="index">
                            <div class="mt-6">
                                <SearchBar placeholderText="Search by retailer name"
                                    @search="(val) => { getRetailerBySearch(0, 50, val); showResultsTableOffers = true }">
                                    <CustomButton small text="" type="default" icon="X"
                                        @click="retailers = []; showResultsTableOffers = false;" />
                                </SearchBar>
                            </div>
                            <EasyDataTable v-if="showResultsTableOffers" :headers="headersTable2" :items="retailers"
                                :loading="loading" v-model:server-options="serverOptions"
                                :server-items-length="serverItemsLength" :hide-footer="true" :no-hover="true"
                                :tableMinHeight="false">
                                <template #loading>
                                    <div class="p-4 w-full flex justify-center">
                                        <svg class="animate-spin text-gray-400 w-12 h-12"
                                            xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                                stroke-width="4"></circle>
                                            <path class="opacity-75" fill="currentColor"
                                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                            </path>
                                        </svg>
                                    </div>
                                </template>
                                <template #empty-message>
                                    <div class="flex justify-center py-4">
                                        <div
                                            class="flex justify-center items-center text-gray-500 rounded-full bg-gray-50 px-5 py-2 ">
                                            <p class="text-sm mr-2">No results</p>
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0 1 12 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5" />
                                            </svg>
                                        </div>
                                    </div>
                                </template>
                                <template #header-activate="header">
                                    <div class="w-full text-right">
                                        {{ header.text }}
                                    </div>
                                </template>

                                <template #item-retailer="retailers">
                                    <LogoAndText :logo="retailers.retailer.logo"
                                        :text="retailers.retailer.retailerName" />
                                </template>
                                <template #item-supplier="retailers">
                                    <Supplier :supplier="retailers.offer.supplier" />
                                </template>
                                <template #item-offertype="retailers">
                                    <OfferTypePill :type="retailers.offer.offerType" />
                                </template>
                                <template #item-cashbackAmount="retailers">
                                    <CashbackPill :text="retailers.displayRules[0].highestCashbackPercentageAmount"
                                        :type="retailers.cashbackEarnings[0].conditions[0].value.type"
                                        :currency="retailers.offer.currency" />
                                </template>
                                <template #header-active="header">
                                    {{ header.text }}
                                </template>
                                <template #item-active="active">
                                    <StatusPill v-if="active.active" text="Live" colour="green" />
                                    <StatusPill v-else text="Deactivated" colour="yellow" />
                                </template>
                                <template #header-action="header">
                                    <div class="w-full text-right">
                                        {{ header.text }}
                                    </div>
                                </template>
                                <template #item-action="retailers">
                                    <div class="flex justify-end items-center py-1 gap-1">
                                        <CustomButton small text="Select Offer" type="navigate"
                                            @click="selectedOffer = retailers" />
                                    </div>
                                </template>
                                <template #item-date="retailers">
                                    <div class="flex justify-end items-center py-1 gap-1">
                                        {{ niceDateTime(retailers.createdOn) }}
                                    </div>
                                </template>
                            </EasyDataTable>
                            <div v-if="selectedOffer != undefined" class="mt-4">
                                <p class="font-semibold text-gray-700 text-sm pb-1">Selected offer:</p>
                                <div class="bg-gray-50 border border-gray-300 rounded-lg px-3 py-2 mb-2">
                                    <div class="flex justify-between items-center">
                                        <div class="flex justify-start items-center gap-x-3">
                                            <LogoAndText class="text-sm" :logo="selectedOffer.retailer.logo"
                                                :text="selectedOffer.retailer.retailerName" />
                                            <CashbackPill
                                                :text="selectedOffer.displayRules[0].highestCashbackPercentageAmount"
                                                :type="selectedOffer.cashbackEarnings[0].conditions[0].value.type"
                                                :currency="selectedOffer.offer.currency" />
                                        </div>
                                        <CustomButton id="removeRetailerRule" small icon="Trash2" type="warning"
                                            @click="selectedOffer = undefined" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </WhiteBox>
            </div>
        </div>



        <CustomButton :loading="this.loading" :disabled="!validCampaign"
            class="w-full shadow-xl transform hover:scale-[1.01] transition duration-200" id="createContract"
            text="Create campaign" type="action" icon="WandSparkles" @click="campaign.slot == 'PROMOTED'  ? createCampaign() : uploadCampaignPhoto()" />

    </div>
</template>

<script setup>
</script>

<script>
import Header from "@/components/Header.vue";
import WhiteBox from "@/components/WhiteBox.vue";
import CustomInput from "@/components/inputs/CustomInput.vue";
import CustomButton from "@/components/inputs/CustomButton.vue";
import { DateTime } from 'luxon';
import SearchBar from '@/components/SearchBar.vue'
import LogoAndText from "@/components/LogoAndText.vue";
import StatusPill from "@/components/StatusPill.vue";
import CashbackPill from "@/components/CashbackPill.vue";
import OfferTypePill from "@/components/OfferTypePill.vue";
import Supplier from "@/components/Supplier.vue";
import CustomSelect from "@/components/inputs/CustomSelect.vue";


export default {
    name: "manage-publsihers",
    components: {
        Header,
        WhiteBox,
        CustomInput,
        CustomButton,
        SearchBar,
        CustomSelect,
        LogoAndText,
        StatusPill,
        CashbackPill,
        OfferTypePill,
        Supplier,
    },
    props: {
    },

    data() {
        return {
            serverOptions: {
                page: 1,
                rowsPerPage: 50,
            },
            campaignType: [
                { "id": "TAKEOVER", "text": "Homepage Takeover" },
                { "id": "FEATURE", "text": "Featured" },
                { "id": "PROMOTED", "text": "Promoted" }

            ],

            selectedAudiences: [],
            selectedOffer: undefined,
            showResultsTable: false,
            showResultsTableOffers: false,

            loading: false,
            headersTable1: [
                { text: "Audience Name", value: "audience.name" },
                { text: "Audience Size", value: "size" },
                { text: "Action", value: "action" },

            ],

            headersTable2: [
                { text: "Retailer", value: "retailer" },
                { text: "Supplier", value: "supplier" },
                { text: "Type", value: "offertype" },
                { text: "Cashback", value: "cashbackAmount" },
                { text: "Status", value: "active" },
                { text: "Action", value: "action" },
            ],
            retailers: [

            ],
            audiences: [

            ],
            errorMessage: "",
            asset: undefined,
            assetURL: undefined,

            campaign: {
                name: "",
                slot: undefined,
                startDate: undefined,
                endDate: undefined,
                associatedAudiences: undefined,
                assetLink: undefined,
                programId: undefined
            }

        }
    },
    created() {

        this.getAudiences(0, 50)
    },
    methods: {
        uploadFile: function (event) {
            this.asset = event.target.files[0];
            if (this.asset) {
                const img = new Image();
                img.onload = () => {

                    if (this.campaign.slot === 'TAKEOVER') {

                        if (img.width === 1080 && img.height === 1080) {
                            this.assetURL = URL.createObjectURL(this.asset);
                            this.errorMessage = ""; // Clear any previous error message
                        } else {
                            this.asset = undefined;
                            this.assetURL = undefined;
                            this.errorMessage = "Incorrect Image Size: Please upload a 1080x1080 pixel image.";
                        }
                    } else if (this.campaign.slot === 'FEATURE') {
                        if (img.width === 1280 && img.height === 720) {
                            this.assetURL = URL.createObjectURL(this.asset);
                            this.errorMessage = ""; // Clear any previous error message
                        } else {
                            this.asset = undefined;
                            this.assetURL = undefined;
                            this.errorMessage = "Incorrect Image Size: Please upload a 1280x720 pixel image.";
                        }
                    }
                };
                img.src = URL.createObjectURL(this.asset);
            }
        },

        async uploadCampaignPhoto() {
            try {
                const formData = new FormData();
                formData.append('multipartFile', this.asset);

                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')

                this.loading = true

                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/campaign/upload-image`, {
                    method: "POST",
                    body: formData,
                    headers: {
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    var dataResponse = await response.json()
                    this.campaign.assetLink = dataResponse.assetURL
                    this.createCampaign()
                }
            } catch (error) {
                return;
            }

        },

        async createCampaign() {
            try {
                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')

                this.campaign.associatedAudiences = this.selectedAudiences.map((val) => val.id)
                this.campaign.programId = this.selectedOffer.id

                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/campaign`, {
                    method: "POST",
                    body: JSON.stringify(this.campaign),
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    this.$router.push("/campaign")
                }
            } catch (error) {
                return;
            }
        },


        async getAudiences(page, size) {
            try {
                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')

                this.loading = true

                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/audience?page=${page}&size=${size}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    var object = await response.json()
                    this.serverItemsLength = object.totalElements
                    this.audiences = object.content
                    this.loading = false
                }

            } catch (error) {
                return;
            }

        },

        niceDateTime(dateObject) {
            return DateTime.fromISO(dateObject).toLocaleString(DateTime.DATE_SHORT)
        },

        async getRetailerBySearch(page, size, retailerSearch) {
            try {
                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')


                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/activated-offer/retailer-search?page=${page}&size=${size}&search=${retailerSearch}&category=`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    var object = await response.json()
                    this.retailers = object.content
                    this.serverItemsLength = object.totalElements
                    this.loading = false
                }

            } catch {
                return
            }
        }

    },
    computed: {
        validCampaign() {

            if (this.campaign.slot == 'PROMOTED') {
                return this.campaign.name != "" && this.campaign.startDate != undefined && this.campaign.endDate != undefined && this.selectedAudiences.length > 0
                    && this.selectedOffer != undefined

            } else {

                return this.campaign.name != "" && this.campaign.startDate != undefined && this.campaign.endDate != undefined && this.selectedAudiences.length > 0
                    && this.asset != undefined && this.selectedOffer != undefined
            }

        }

    },
    watch: {
        serverOptions: {
            deep: true,
            handler(val) {
                this.getRetailers(val.page - 1, val.rowsPerPage)
            }
        }
    }
}
</script>